export default __webpack_public_path__ + "bed1bcfb95b16a7cfa64cadc6e076ee2.mp4";